<template>
  <div class="page_search_area">
    <el-form :inline="true">
      
      <el-form-item label="单位简称：" class="search_item_area">
        <el-input
          v-model.trim="searchData.unitShortName"
          placeholder="请输入单位简称"
          maxlength="10"
          clearable
        ></el-input>
      </el-form-item>

      <el-form-item label="手机号：" class="search_item_area">
        <el-input
          v-model.trim="searchData.tel"
          placeholder="请输入手机号"
          maxlength="11"
          @input="(v)=>{this.searchData.tel = v.replace(/[^\d]/g,'')}"
          clearable
        ></el-input>
      </el-form-item>

      <el-form-item label="状态：" class="search_item_area">
        <el-select v-model="searchData.state" placeholder="请选择">
          <el-option
            v-for="item in arrState"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="企业微信号：" class="search_item_area">
        <el-input
          v-model.trim="searchData.enterpriseMobile"
          placeholder="请输入企业微信手机号"
          maxlength="11"
          @input="(v)=>{this.searchData.enterpriseMobile = v.replace(/[^\d]/g,'')}"
          clearable
        ></el-input>
      </el-form-item>

      <el-form-item label="创建日期：" class="search_item_area_a">
        <el-date-picker
          v-model="searchData.dateRange"
          type="daterange"
          range-separator="-"
          value-format="yyyy-MM-dd"
          start-placeholder="年/月/日"
          end-placeholder="年/月/日"
          :picker-options="datePickerOptions"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item class="search_item_area_a">
        <el-button class="search_btn" type="primary" @click="btnSearchClick">查询</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import mixins from "./Mixins";
export default {
  mixins: [mixins],
  data() {
    return {
      arrState: [
        { name: "全部", id: "" },
        { name: "已启用", id: "1" },
        { name: "已停用", id: "0" },
        { name: "已解绑", id: "2" },
      ],
      datePickerOptions: {
        disabledDate(time) {
          return (
            time.getTime() > Date.now() ||
            time.getTime() < new Date("2021-01-01")
          );
        },
      },
    };
  },
  computed: {
    searchData() {
      return this.Operation.searchData;
    },
  },
  methods:{
    btnSearchClick() {
      this.setSearchData_M({
        page:1
      })
      this.getTableList_A();
    }
  }
};
</script>

<style lang="stylus" scoped>
.page_search_area {
  height:145px;
  .btn_out {
    background-color: #F66915;
    width: 100px;
    height: 40px;
    float: right;
    margin-top: -60px;
    margin-right: 30px;
    color: #fff;
    padding: 0 20px;

    .btn_content {
      display: flex;
      align-items: center;
    }

    .icon-upload {
      background: url('~@/assets/images/Statistics/icon_out.png') no-repeat;
      width: 18px;
      height: 18px;
      display: inline-block;
      margin-right: 10px;
    }

    .text_upload {
      display: inline-block;
    }
  }

  .search_item_area_a {
    margin: 0 0 20px 30px;  

    .search_btn {
                background-color: #2C90FF;
                width: 100px;
                height: 40px;
                
            }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/PartI/OperationAccount/components/accountSearch.vue